import { render, staticRenderFns } from "./signin-page.vue?vue&type=template&id=47150dd0&"
import script from "./signin-page.vue?vue&type=script&lang=js&"
export * from "./signin-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports